module.exports = __webpack_public_path__ + "img/novembro_azul.2e4dbf74.svg";